// extracted by mini-css-extract-plugin
export var fullWidthButton = "_104-0";
export var tagInputDisabled = "_104-1";